// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsuredPersonSelection_options__R8F4O {
  display: flex;
  gap: 12px;
  width: 100%;
  height: 190px;
  margin-bottom: 28px;
}

.InsuredPersonSelection_option__Hz2DB {
  width: 50%;
  height: 100%;
  cursor: pointer;
}

.InsuredPersonSelection_option-content__baWhs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  text-align: center;
  font-weight: 400;
}

@media screen and (max-width: 600px) {
  .InsuredPersonSelection_options__R8F4O {
    gap: 9px;
    height: 100px;
    margin-bottom: 20px;
  }
  .InsuredPersonSelection_option-content__baWhs {
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimApplication/InsuredPersonSelection/InsuredPersonSelection.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAIF;;AADA;EACE,UAAA;EACA,YAAA;EACA,eAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAIF;;AADA;EACE;IACE,QAAA;IACA,aAAA;IACA,mBAAA;EAIF;EADA;IACE,SAAA;EAGF;AACF","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.options {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  height: 190px;\n  margin-bottom: 28px;\n}\n\n.option {\n  width: 50%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.option-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  font-weight: 400;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .options {\n    gap: 9px;\n    height: 100px;\n    margin-bottom: 20px;\n  }\n\n  .option-content {\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"options": `InsuredPersonSelection_options__R8F4O`,
	"option": `InsuredPersonSelection_option__Hz2DB`,
	"option-content": `InsuredPersonSelection_option-content__baWhs`
};
export default ___CSS_LOADER_EXPORT___;
